import { useSearchParams } from 'react-router-dom';

const monoFont = "'IBM Plex Mono', monospace";

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: '#F7F6F2' }}
    >
      <div style={{ textAlign: 'center', maxWidth: 420, padding: 24 }}>
        <div
          style={{
            fontFamily: monoFont,
            fontSize: 24,
            fontWeight: 300,
            color: '#000000',
            marginBottom: 32,
          }}
        >
          CRIAAA
        </div>

        <div
          style={{
            fontFamily: monoFont,
            fontSize: 16,
            fontWeight: 400,
            color: '#000000',
            marginBottom: 16,
          }}
        >
          Verifique seu email.
        </div>

        <div
          style={{
            fontFamily: monoFont,
            fontSize: 13,
            fontWeight: 300,
            color: 'rgba(0,0,0,0.6)',
            lineHeight: 1.6,
          }}
        >
          Enviamos um email de confirmação para{' '}
          {email ? (
            <strong style={{ color: '#000000' }}>{email}</strong>
          ) : (
            'seu email'
          )}
          . Confirme para acessar o CMS.
        </div>

        <div
          style={{
            fontFamily: monoFont,
            fontSize: 11,
            fontWeight: 300,
            color: 'rgba(0,0,0,0.35)',
            marginTop: 40,
          }}
        >
          Não recebeu? Verifique a caixa de spam.
        </div>
      </div>
    </div>
  );
}
